import React from 'react';
import PropTypes from 'prop-types';
import { Row, Col } from 'react-bootstrap';
import { Price } from '../../../../../../../src/web/components';
import styles from '../Actions.scss';

const AmountDueToday = ({ reservationFee }) => (
  <div>
    <div className={styles.subHeading}>Amount Due Today</div>
    <Row className={styles.descriptionWell}>
      <Col xs={6}>Reservation Fee</Col>
      <Col xs={6} className="text-end">
        <Price className={styles.resPrice} value={reservationFee} />
      </Col>
    </Row>
  </div>
);

AmountDueToday.propTypes = {
  reservationFee: PropTypes.number,
};

AmountDueToday.defaultProps = {
  reservationFee: 0,
};

export default AmountDueToday;
